import Api from '../../api'
import axios from '@/js/api'
// import {Message}from 'element-ui'
import router from '../../router'
import date from '../../js/date.js'
const state ={
    listParameter:{
        PageIndex:1, //分页
        PageCount:10, //分页
        keyword:'', //关键词
        startDate:'', //开始时间
        endDate:'', //结束时间
        status:'0', //全部0，已抽样 10， 已分发：15，进行中，已完成 50，已取消 -1
    },
    list:[],
    total:0,
    totalsecond:0,
    pageIndex:{
    	page:1,
    	pageIndex:1
    },
    loading:true,
    pickerDate:{
        date:[]
    },
    secondListParameter:{
        SamplingTaskGuid: '',
        expertUserGuid:'',
        HospitalUid: '',
        DoctorGuid: '',
        BodyPart: '',
        Status: 0,
        DoctorType:0, 
        EndDate: '',
        PageIndex: 1,
        PageCount: 10,
        ModalityType:'',
        keyName:'',
		DoctorName:''
    },
    secondList:[],
    secondListFiltersOrganization:[],
    secondListFiltersDoctor:[],
    secondListFiltersType:[],
    secondListFiltersStatus:[],
    splitScreen:false,
    //删除列表
    SamplingTaskGuId:{
        SamplingTaskGuid:'',
        expertUserGuid:''
    },
    distributionBox:{
    	open:false
    },
    experts:{
        complete:0,
        sampling:0,
        pending:0,
    },
    taskSecond:false,
    reportListByTaskVal:[],
    taskListTitle:{},
    setTaskStatus:0,
    distributionFrom:{
    	DistributionType:1,
    	DistributionMethod:1
    },
    distributionArr:{
    	SamplingTaskGuid:''
    },
    //新建工作组
	newWorkTeamFrom: {
		ExpertGroupGuid: "",
		name: "",
		Experts: [],
		Enable: true,
		Creator: "",
		Mender: "",
		type: ''
	},
	surplusValue:{
		num:0
    },
    statusList:'0',
    taskInfo:{},
    statusBar:[],//状态
    distributionInfo:[],
	resultList:[],
    hospitals:[],
    iconList:['iconfont iconicon-Created','iconfont iconicon-Assigned','iconfont iconicon-Qualitycontrol','iconfont iconicon-complete'],
	qcresultsByTaskList:[],
	qcresultsList:{
		Name:'',
		expertUserId:'',
		ReportGuid:'',
		SamplingTaskGuid:''
	},
	reviewName:{
		name:'',
		exports:false,
		SubjectType:0
	},
	doctorsResultList:[],
	getExpertReportListParameter:{
		ExpertUserGuid:'',
		SamplingTaskGuid:'',
		KeyName:'',
		HospitalGuid:'',
		DoctorType:0,
		DoctorName:'',
        PageIndex: 1,
        PageCount: 10,
	},
	statisticsParameter:{
		startdt:'',
		enddt:''
	},
	expertScoreStatisticList:{},
	exportStatiscsParamters:{
		keyword:'',
		hospitalGuid:'',
		category:'0',
		startDate:'',
		endDate:'',
		pageIndex:1,
		pageCount:10,
		total:0
	},
	exportStatiscsList:[],
	changeReportsList:{},
	GetCanChangableList:{},
	ChangeReportsList:{},
	TaskStatisticByMonthParameter:{
	  "Status": "",
	  "StartMonth": "",
	  "EndMonth": "",
	  "PageIndex": 1,
	  "PageCount": 10
	},
	GetTaskStatisticByMonthList:{},
	GetCanChangableReportsParameter:{
	  "SamplingTaskGuid": "",
	  "ReportGuid": "",
	  "HospitalGuid": "",
	  "DoctorGuid": "",
	  "DoctorName": "",
	  "ModalityType": "",
	  "CheckintItem": "",
	  "pageIndex": 1,
	  "pageCount": 10
	},
    modalityTypeSelect:[],
    numLoading:false
};
const getters={
 
};
const mutations={
	setReportModality(state, res){
        state.modalityTypeSelect = res.data.Data;
		state.modalityTypeSelect.forEach(item=>{
			item.text = item.Name;
		})
	},
    setnumLoading(state,arr){
        state.numLoading=arr;
    },
	setLoading(state,arr){
        state.loading=arr;
    },
	setLoadings(state,arr){
        state.loading=arr;
    },
	clearparameter(state,arr){
		state.getExpertReportListParameter.ExpertUserGuid = '';
		state.getExpertReportListParameter.KeyName = '';
		state.getExpertReportListParameter.HospitalGuid = '';
		state.getExpertReportListParameter.DoctorName = '';
	},
	// 清空数据
	clearSecondListParameter(state,arr){
		state.secondListParameter.HospitalUid = '';
		state.secondListParameter.DoctorGuid = '';
		state.secondListParameter.DoctorName = '';
		state.secondListParameter.HospitalGuid = '';
	},
	//清空数据
	clearSecondListParameter(state,arr){
		state.SamplingTaskGuid='';
        state.expertUserGuid='';
        state.HospitalUid='';
        state.DoctorGuid='';
        state.BodyPart= '';
        state.Status= 0;
        state.DoctorType=''; 
        state.EndDate= '';
        state.PageIndex= 1;
        state.PageCount= 10;
        state.ModalityType='';
        state.keyName='';
	},
    //初始化二级菜单
    setSecondList(state,arr){
        state.secondList=[];
    },

    //初始化参数
    clearInit(state){
        state.listParameter.PageIndex=1;
        state.listParameter.keyword=''
        //state.listParameter.startDate=startDate;
        //state.listParameter.endDate=endDate;
        state.splitScreen=false; 
        state.pickerDate.date=[]   
    },
	GetDoctorsResultMu(state,arr){
		state.doctorsResultList = arr.data.Doctors;
	},
	//抽样任务二级页面显示
    SetReportListByTaskVal(state,arr){
    	state.reportListByTaskVal = arr.data.Reports;
    	state.totalsecond = arr.data.TotalCount;
    	state.loading = false;
    },
	// toop专家列表赋值
	GetQCResultsByTaskMu(state,arr){
		state.qcresultsByTaskList = arr.data.Experts;
	},
    //打开二级页面
   setTaskSecond(state,arr){
   	state.taskSecond = arr;
   },
   SetTaskInfo(state,arr){
       state.taskInfo=arr.data.Task
   },
   SetStatusBar(state,arr){
   	state.statusBar=arr.data.Status;
   	state.statusBar.forEach((item,index)=>{
   		item.icon = state.iconList[index];
   	})
   },
   SetHospitalInfo(state,arr){
       state.hospitals=arr.data.Hospitals
   },
   // 任务详情赋值
   SetDistributionInfo(state,arr){
       state.distributionInfo=arr.data.Distributions;
	   state.resultList = arr.data.Hospitals;
   },
    //任务列表
    SetReporterReportList(state,arr){        
        state.list=arr.data.SamplingTasks;
        state.list.map(res=>{
            //全部0，已抽样 10， 已分发：15，进行中:20，已完成 50，已取消 -1
            if(res.Status==5){
                res.StatusCode='已创建'
            }
            if(res.Status==10){
                res.StatusCode='已抽样'
            }
            if(res.Status==15){
                res.StatusCode='已分配'
            }
            if(res.Status==20){
                res.StatusCode='进行中'
            }
            if(res.Status==50){
                res.StatusCode='已完成'
            }
            if(res.Status==-1){
                res.StatusCode='已取消'
            }
        })
        state.total=arr.data.TotalCount;
        state.experts.complete=arr.data.QCedCount;
        state.experts.sampling=arr.data.QCingCount;
        state.experts.pending=arr.data.ToQCCount;
    },
    currentChanges(state,val){
        state.listParameter.PageIndex=val
    },
    currentChangesSecond(state,val){
    	state.pageIndex.page = val;
    	state.pageIndex.PageIndex = val;
		state.getExpertReportListParameter.PageIndex = val;
    },
    setDatePicker(state,val){
        if(val){
            state.listParameter.startDate= date.dataNumber(val[0]);
            state.listParameter.endDate= date.dataNumber(val[1]);
        }
        else{
            state.listParameter.startDate='';
            state.listParameter.endDate='';
        }
    },
    setDoctorStatus(state,val){
    	state.statusList = val;
        state.listParameter.status=val;
    },
    setTaskStatus(state,val){
        state.setTaskStatus=val
    },
    //二级菜单
    SetReportListByTask(state,val){
        state.loading=false;
        state.list.map(res=>{
            if(res.SamplingTaskGuid==state.secondListParameter.SamplingTaskGuid){
                res.children=val.data.Reports;
            }
        })
       
    },
    //分屏
    setSplitScreen(state,arr){
       state.splitScreen = arr;
   },
   //
   setSecondListParameter(state,arr){
     state.secondListParameter.SamplingTaskGuid=arr.SamplingTaskGuid
    // state.secondListParameter.Status=arr.Status
   },
   SetReportListWhere(state,arr){
        state.secondListFiltersOrganization=[];
       state.secondListFiltersDoctor=[];
       state.secondListFiltersType=[];
       state.secondListFiltersStatus=[];
       if(arr){
        arr.data.Where.map(res=>{
         if(res.type==1){
            state.secondListFiltersOrganization.push(res);
         }
         if(res.type==2){
            state.secondListFiltersDoctor.push(res);
         }
         if(res.type==3){
            state.secondListFiltersType.push(res);
         }
         if(res.type==4){
            state.secondListFiltersStatus.push(res);
         }
        })
       }
   },
   GetToDistributeInfoMu(state,arr){
   		state.distributionFrom = arr.data.ToDistributeInfo;
   		state.surplusValue.num = arr.data.ToDistributeInfo.Total;
   },
   GetExpertScoreStatisticMu(state,arr){
   		state.expertScoreStatisticList = arr.data;
   },
   ExportGetTaskListMu(state,arr){
   		state.exportStatiscsList = arr.data;
   },
   GetCanChangableMu(state,res){
   		state.GetCanChangableList = res.data;
   },
   ChangeReportsMu(state,res){
   		state.ChangeReportsList = res.data;
   },
   GetTaskStatisticByMonthMu(state,res){
   		state.GetTaskStatisticByMonthList = res.data;
		state.GetTaskStatisticByMonthList.Months.forEach(item=>{
			item.hasChildren = true;
		})
   },
   changeReportsListMu(state,res){
		state.GetCanChangableReportsParameter.pageIndex = 1;
   		state.changeReportsList = res;
   },
};
const actions={
    //设备类型
    GetReportModality({
        state,
        commit,
        dispatch
    },arr) {
        axios.ajaxGet('get', Api.api.manager.GetReportModality).then(res => {
            if(res.data.StatusCode){
                commit('setReportModality', res);
            }
        })
    },
	//获取待分 配信息
    GetToDistributeInfo({commit,state,dispatch}){
        axios.ajaxGet('get',Api.api.newTask.GetToDistributeInfo,{
        	samplingTaskGuid:state.SamplingTaskGuId.SamplingTaskGuid
        }).then(res=>{
           commit('GetToDistributeInfoMu',res)
           commit('setLoading',false)
        })
    },
    // 检查是否可以分配任务
    ChechTaskIsDistribution({ commit, state }, options) {
       return axios.ajaxPost('post',Api.api.newTask.ChechTaskIsDistribution, options)
    },
	//提交分配
    PostTaskDistribution({commit,state,dispatch},arr){
        axios.ajaxPost('post',Api.api.newTask.PostTaskDistribution,{
        	SamplingTaskGuid:state.SamplingTaskGuId.SamplingTaskGuid,
        	DistributionType:arr.DistributionType,
        	DistributionMethod:arr.DistributionMethod,
        	Experts:arr.Experts
        }).then(res=>{
            commit('setLoading',false)
            if (res.status == 200) {
                router.push('/home/manager/task/taskall');
            }else{
                ELEMENT.Message.error("分配失败")
            }
        })
    },
    //质控管理员详情
    GetCreatedTaskList({commit,state,dispatch}){
        axios.ajaxGet('get',Api.api.manager.GetCreatedTaskList,state.listParameter).then(res=>{
           commit('SetReporterReportList',res)
           //第一次点击不出现数据bug
           if(res){
				if(res.data.SamplingTasks.length>0){
					commit('setSecondListParameter',res.data.SamplingTasks[0])
				}
			} 
        	commit('setLoading',false)
        })
    },
    //质控管理员已分配后的撤回
    RollBackExpertTaskByTaskId({commit,state,dispatch},arr){
        axios.ajaxPost('post',Api.api.manager.RollBackExpertTaskByTaskId,arr).then(res=>{
            if (res.status == 200) {
                ELEMENT.Message.success("撤回成功")
                dispatch('GetCreatedTaskList')
            }
        })
    },
    GetTaskDetail({commit,state,dispatch}){
        axios.ajaxGet('get',Api.api.manager.GetTaskDetail,{
        	samplingTaskGuid:state.SamplingTaskGuId.SamplingTaskGuid
        }).then(res=>{
            if(res){
                commit('SetTaskInfo',res)
                commit('SetStatusBar',res)
                commit('SetHospitalInfo',res)
                commit('SetDistributionInfo',res)
            }
        })
    },
    //质控管理员详情二级
    GetReportListByTask({commit,state,dispatch}){
    	state.secondListParameter.PageIndex = state.pageIndex.page;
        axios.ajaxGet('get',Api.api.manager.GetReportListByTask,state.secondListParameter).then(res=>{
           commit('SetReportListByTaskVal',res)
           commit('setLoading',false)
           dispatch('GetReportListWhere')
        })
    },
    //专家分配报告列表
    GetExpertReportList({commit,state,dispatch}){
        axios.ajaxPost('post',Api.api.manager.GetExpertReportList,state.getExpertReportListParameter).then(res=>{
           commit('SetReportListByTaskVal',res)
           dispatch('GetReportListWhere')
           commit('setLoading',false)
        })
    },
	// 抽样结果医院/技师
	GetDoctorsResult({commit,state},arr){
	    axios.ajaxGet('get',Api.api.manager.GetDoctorsResult,{
			SamplingTaskGuid:arr.SamplingTaskGuid,
			HospitalUid:arr.HospitalUid,
			DoctorType:arr.DoctorType
			}).then(res=>{
	       commit('GetDoctorsResultMu',res)
	       commit('setLoading',false)
	    })
	},
    GetReportListWhere({commit,state}){
        axios.ajaxGet('get',Api.api.manager.GetReportListWhere,{SamplingTaskGuid:state.secondListParameter.SamplingTaskGuid}).then(res=>{
           commit('SetReportListWhere',res)
           commit('setLoading',false)
       
        })
    },
    //取消任务
    cancelList({commit,state,dispatch}){
        axios.ajaxPost('post',Api.api.manager.cancelList,state.SamplingTaskGuId).then(res=>{
            dispatch('GetCreatedTaskList')
            commit('setLoading',false)
            ELEMENT.Message.success("删除成功")
           //commit('SetReportListWhere',res)
        })
    },
	//删除任务
	UpdateTaskEnable({commit,state,dispatch},arr){
	    axios.ajaxPost('post',Api.api.manager.UpdateTaskEnable,arr).then(res=>{
	        dispatch('GetCreatedTaskList')
	        commit('setLoading',false)
	        ELEMENT.Message.success("删除成功")
	    })
	},
	//任务详情-报告列表-专家列表
    GetQCResultsByTask({commit,state},arr){
        axios.ajaxGet('get',Api.api.manager.GetQCResultsByTask,{
			samplingtaskguid:arr.samplingtaskguid,
			reportGuid:arr.reportGuid
		}).then(res=>{
            commit('GetQCResultsByTaskMu',res)
        })
    },
	//专家统计
	GetExpertScoreStatistic({commit,state},arr){
		commit('setLoading',true);
		commit('breadcrumb/setLoading',true,{root:true})
	     return axios.ajaxGet('get',Api.api.manager.GetExpertScoreStatistic,state.statisticsParameter).then(res=>{
	        commit('GetExpertScoreStatisticMu',res)
			commit('setLoading',false);
			commit('breadcrumb/setLoading',false,{root:true})
	    }).finally(() => {});
	},
	//专家统计
	SendSMS2Expert({commit,state},arr){
	     return axios.ajaxGet('get',Api.api.manager.SendSMS2Expert,arr).then(res=>{}).finally(() => {});
	},
	//导出任务列表
	GetTaskList({commit,state},arr){
		commit('breadcrumb/setLoading',true,{root:true})
	     return axios.ajaxGet('get',Api.api.experts.ExportGetTaskList,state.exportStatiscsParamters).then(res=>{
	        commit('ExportGetTaskListMu',res)
			commit('breadcrumb/setLoading',false,{root:true})
	    }).finally(() => {});
	},
	// 更换报告列表
	GetCanChangableReports({commit,state,dispatch},arr){
		commit('breadcrumb/setLoading',true,{root:true})
	    axios.ajaxPost('post',Api.api.manager.GetCanChangableReports,arr).then(res=>{
	        commit('GetCanChangableMu',res)
	        commit('breadcrumb/setLoading',false,{root:true})
	    })
	},
	// 更换报告
	ChangeReports({commit,state},arr){
		// commit('breadcrumb/setLoading',true,{root:true})
	    //  return axios.ajaxPost('post',Api.api.manager.ChangeReports,arr).then(res=>{
	    //     commit('ChangeReportsMu',res)
	    //     commit('breadcrumb/setLoading',false,{root:true})
	    // }).finally(() => {});
        commit('breadcrumb/setLoading', true, { root: true });
        return axios.ajaxPost('post', Api.api.manager.ChangeReports, arr)
          .then(res => {
            commit('ChangeReportsMu', res);
            return res;  // 返回 res
          })
          .finally(() => {
            commit('breadcrumb/setLoading', false, { root: true });
          });
	},
	// 任务按月统计
	GetTaskStatisticByMonth({commit,state}){
		commit('breadcrumb/setLoading',true,{root:true})
	     return axios.ajaxPost('post',Api.api.manager.GetTaskStatisticByMonth,state.TaskStatisticByMonthParameter).then(res=>{
	        commit('GetTaskStatisticByMonthMu',res)
	        commit('breadcrumb/setLoading',false,{root:true})
	    }).finally(() => {});
	},
	SendHospitalOk2CD({commit,state},arr){
		commit('breadcrumb/setLoading',true,{root:true})
	     return axios.ajaxPost('post',Api.api.manager.SendHospitalOk2CD,{
		  "SamplingTaskGuid": arr.SamplingTaskGuid,
		  "HospitalGuid": arr.HospitalGuid,
		  "Type": arr.Type,
		  "DoctorName": arr.DoctorName
		}).then(res=>{
	        commit('breadcrumb/setLoading',false,{root:true})
	    }).finally(() => {});
	},

}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
